module.exports = __webpack_public_path__ + "static/media/test.a56a3a8e.PNG";